export const USERS_FOR_SEE_ALL_TT_FILTER_SET = 'at/systemSettings/USERS_FOR_SEE_ALL_TT_FILTER_SET'
export const ALLOW_USERS_TO_SEE_ALL_TT_SET = 'at/systemSettings/ALLOW_USERS_TO_SEE_ALL_TT_SET'
export const ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES = 'at/systemSettings/ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES'
export const SHOW_USERNAME_IN_REPORTS_SET = 'at/systemSettings/SHOW_USERNAME_IN_REPORTS_SET'
export const HIDE_NOT_ASSIGNED_TT_DETAILS_SET = 'at/systemSettings/HIDE_NOT_ASSIGNED_TT_DETAILS_SET'
export const HIDE_DETAILS_ON_LOCK_TT_SET = 'at/systemSettings/HIDE_DETAILS_ON_LOCK_TT_SET'
export const HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET = 'at/systemSettings/HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET'
export const TTM_CAN_SEE_AUTO_APPROVED_SET = 'at/systemSettings/TTM_CAN_SEE_AUTO_APPROVED_SET'

export const ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE = 'at/systemSettings/ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE'
export const ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE = 'at/systemSettings/ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE'
export const SHOW_USERNAME_IN_REPORTS_COLLAPSE = 'at/systemSettings/SHOW_USERNAME_IN_REPORTS_COLLAPSE'
export const HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE = 'at/systemSettings/HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE'
export const HIDE_DETAILS_ON_LOCK_TT_COLLAPSE = 'at/systemSettings/HIDE_DETAILS_ON_LOCK_TT_COLLAPSE'
export const HIDE_ACCOUNT_SETTINGS_COLLAPSE = 'at/systemSettings/HIDE_ACCOUNT_SETTINGS_COLLAPSE'
export const TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE = 'at/systemSettings/TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE'



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/actionTypes.js